'use client';

import { useMemo } from 'react';

import { getClientRuntimeConfig } from '@/lib/config/runtime';

export function useMarketingUrls() {
  return useMemo(() => {
    const config = getClientRuntimeConfig();
    const webDomain =
      config?.webDomain ||
      (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3001');
    const apiBaseUrl =
      config?.apiBaseUrl ||
      process.env.NEXT_PUBLIC_API_BASE_URL ||
      'http://localhost:3000';

    return {
      webDomain: webDomain.replace(/\/$/, ''),
      apiBaseUrl: apiBaseUrl.replace(/\/$/, ''),
    };
  }, []);
}
